<template>
  <v-navigation-drawer v-model="toggler" app clipped>
    <v-list dense>
      <v-subheader>MENÚ</v-subheader>
      <v-list-item link to="/smartrecovery/campaña">
        <v-list-item-action>
          <v-icon>mdi-chart-line</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Generar campaña</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Seguimiento resultados</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link @click="$store.commit('setLink', 'https://bit.ly/38p7rbg'); $router.push('/smartrecovery/indices')">
          <v-list-item-action>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Índice de Pérdidas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$store.commit('setLink', 'https://bit.ly/3ctCxSd'); $router.push('/smartrecovery/indices')">
          <v-list-item-action>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Mapa de Pérdidas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$store.commit('setLink', 'https://bit.ly/2vvPaMd'); $router.push('/smartrecovery/indices')">
          <v-list-item-action>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Operación Control Pérdidas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$store.commit('setLink', 'https://bit.ly/3arr9oc'); $router.push('/smartrecovery/indices')">
          <v-list-item-action>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Operación Medida</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$store.commit('setLink', 'https://bit.ly/2vwud3I'); $router.push('/smartrecovery/indices')">
          <v-list-item-action>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Cadena Técnico/Comercial</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$store.commit('setLink', 'https://bit.ly/2TmqoXK'); $router.push('/smartrecovery/indices')">
          <v-list-item-action>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Monitoreo de Zonas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <!-- <v-list-item link to="/smartchronos">
        <v-list-item-action>
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Volver a Smartchronos</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <!-- <v-list-item link to="/smartrecovery/reportes">
        <v-list-item-action>
          <v-icon>mdi-file-pdf</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Reportes Estrategico</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/smartrecovery/reportesoperacion">
        <v-list-item-action>
          <v-icon>mdi-file-pdf</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Reportes de operacion</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import Vue from "vue";
import { Auth } from "../classes/Auth";
import axios from "axios";

export default Vue.extend({
  name: "Sidebar",
  props: ["drawer"],
  computed: {
    toggler: {
      get: function() {
        return this.drawer;
      },
      set: function(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  // mounted() {
  //   this.getproyect();
  // },
  data() {
    return {
      facturacion: false,
      auth: new Auth()
    };
  },
  methods: {
    // getproyect: function() {
    //   this.facturacion = this.auth.getProject().name == "DAVIVIENDA";
    // },
    invoiceTool: function() {
      const fd = new FormData();
      fd.set("token", this.auth.getToken());
      // const token = this.auth.getToken();

      this.$awn.async(
        axios({
          method: "POST",
          url: "http://45.33.113.68:2035/login",
          data: fd
        }),
        res => {
          if (res.data) {
            const { o } = res.data;
            if (o) {
              location.href = `http://45.33.113.68:2035/login/usuario:${o.username}/password:${o.identificacion}/extern:true`;
            } else {
              this.$awn.warning(
                "El usuario no existen en el software de facturación"
              );
            }
          } else {
            this.auth.logout();
            this.$router.push("/");
          }
        },
        err => this.$awn.alert(err.data)
      );
    }
  }
});
</script>
<style lang="sass" scoped>

    #sidebar
        position: fixed
        left: 0
        top: 0
        width: 250px
        height: 100%
        border-right: 1px solid rgba(#000, .1)

</style>